import React, {createRef, useContext, useEffect, useState} from 'react';
import __ from 'lodash';
import {
  Icon,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
} from '@material-ui/core';
import {Alert} from "./";
import SystemContext from "../SystemContext";

const Form = (props) => {
  const formRef = createRef();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const eventBus = SystemData.eventBus;

  const [record, setRecord] = useState(__.cloneDeep(props.record||{}));
  const [propsRecord, setPropsRecord] = useState(JSON.stringify(props.record||{}));
  const [state, setState] = useState({open: false, error: false, errorMessage: null});

  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: "",
    ...props.alert
  });

  if (JSON.stringify(props.alert) !== state.propsAlert) {
    setAlert({
      open: false,
      severity: "error",
      message: "",
      ...props.alert
    });
    setState({...state,  propsAlert: JSON.stringify(props.alert)});
  }

  if (propsRecord !== JSON.stringify(props.record)) {
    setState({...state, open: props.open});
    setPropsRecord(JSON.stringify(props.record||{}));
    setRecord(__.cloneDeep(props.record||{}));
  }

  const defaultButtons = {
    save:{icon: "check_circle", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
    cancel:{icon: "cancel", label: "Cancel", color: "primary"}
  };

  const title = props.title;
  const buttons = props.buttons? {...props.buttons}:{...defaultButtons};
  const onChange = props.onChange;
  const Validator = props.validator;
  const validatorPosition = props.validatorPosition||"top";
  const formId = props.formId || "FormWithoutATitle";

  const changeButtonState = (changes) => {
    eventBus.trigger(`FormDialog.${formId}.changeButtonState`, changes);
  }

  const buttonHandler = (buttonPressed) => {
    if (buttonPressed === "cancel") {
      onChange({buttonPressed, record: props.record, oldRecord: props.record, formRef});
      setRecord(props.record);
    } else {
      onChange({buttonPressed, record, oldRecord: props.record, formRef});
    }
  }

  let keyId = 0;
  const usedKeys = {}
  const getKey = (id, name) => {
    let key = id || name || `_field(${++keyId})`;
    if (usedKeys[key]) {
      key = `_field(${++keyId})`;
    }
    usedKeys['key'] = true;
    return key;
  }

  const changeRecord = (changes) => {
    const newRecord = {...record, ...changes};
    setRecord(newRecord);
  }

  const defaultsRecord = {};
  const addOnChangeToChildren = (_child, i = 0) => {
    let child = _child;
    if (typeof child === 'function') {
      child = _child(record, changeRecord, changeButtonState);
    }
    if (Array.isArray(child)) {
      return child.map(addOnChangeToChildren);
    }
    if (!child || !child.props) return child;
    const childsOnChange = child.props.onChange;
    const onRecordChange = props.onRecordChange;
    const id=getKey(child.props.id, child.props.name);

    const internalElement = (typeof child.type === "string" && child.type.substring(0,1) === child.type.substring(0,1).toLowerCase());
    if (child.props && child.props.children && (internalElement || child.props.checkChildren || child.props.checkchildren)){
      if (Array.isArray(child.props.children)){
        const children = child.props.children.map(addOnChangeToChildren);
        const { checkChildren, ...childProps } = child.props;
        const filteredChild = { ...child, props: childProps }
        const changes = {};
        if (!internalElement && !childProps.key) {
          changes['key']=`form_field_${id}`;
        }
        return React.cloneElement(filteredChild, {...changes}, children);
      } else {
        const children = addOnChangeToChildren(child.props.children);
        const { checkChildren, ...childProps } = child.props;
        const filteredChild = { ...child, props: childProps }
        const changes = {};
        if (!internalElement && !childProps.key) {
          changes['key']=`form_field_${id}`;
        }
        return React.cloneElement(filteredChild, {...changes}, [children]);
      }
    }

    if (props.open) {
      const changes = {
        onChange: (e)=>{
          let value = e;
          if (e && e.target) {
            value = e.target.type==='checkbox'?e.target.checked:e.target.value;
          }
          if (child.props && typeof child.props.beforeChange === "function") {
            value = child.props.beforeChange(value);
          }

          const formOnChange = (value) => {
            const newRecord = {...record};
            newRecord[id] = value;
            setRecord(newRecord);
            if (onRecordChange) {
              onRecordChange(newRecord);
            }
          }

          const recordChange = (changes, replace=false) => {
            const newRecord = replace===true?{...changes}:{...record, ...changes};
            setRecord(newRecord);
            if (onRecordChange) {
              onRecordChange(newRecord);
            }
          }

          if (childsOnChange) {
            childsOnChange(value, {onChange: formOnChange, recordChange, record});
          } else {
            formOnChange(value);
          }
        }
      };

      if (record[id] === undefined && child.props.defaultValue !== undefined) {
        defaultsRecord[id] = child.props.defaultValue;
      }
      changes['value'] = record[id]===null?"":record[id];
      changes['checked'] = record[id]===null?"":record[id];
      if (!Object.prototype.hasOwnProperty.call(child.props, 'key')) {
        changes['key'] = getKey(child.props.id, child.props.name);
      }

      const { checkChildren, ...childProps } = child.props;
      const filteredChild = { ...child, props: childProps }
      const newChild = React.cloneElement(filteredChild, {...changes});
      return newChild;
    }
  }
  let children = null;
  if (props.children && props.open) {
    if (Array.isArray(props.children)){
      children = props.children.map(addOnChangeToChildren);
    } else {
      children = addOnChangeToChildren(props.children);
    }
    if (Object.keys(defaultsRecord).length > 0) {
      const newRecord = {...record, ...defaultsRecord};
      setRecord(newRecord);
      if (props.onRecordChange) {
        props.onRecordChange(newRecord);
      }
    }
  }

  // const Form = (props) => (
  //   <div type="form" {...(__.omit(props, ['children']))}>{props.children}</div>
  // )

  const errorHeight = (alert.open || state.error)? 48 : 0;
  const formHeight = {maxHeight: `calc(100vh - ${props.formHeightOffset + errorHeight}px)`,minHeight: `calc(100vh - ${props.formHeightOffset + errorHeight}px)`}

  const ButtonBar = (props) => {
    const buttons = props.buttons;
    const [buttonStates, setButtonStates] = useState({});

    useEffect(()=> {
      const handleChangeButtonState = (changes) => {
        setButtonStates({...buttonStates, ...changes});
      }
      eventBus.bind(`FormDialog.${formId}.changeButtonState`, handleChangeButtonState);

      return ()=> {
        eventBus.unbind(`FormDialog.${formId}.changeButtonState`, handleChangeButtonState);
      }
    },[buttonStates]);

    return (
      <>
        {Object.entries(buttons).map(([key, buttonProps]) => {
          const button = __.omit(buttonProps,['label', 'icon', 'iconOptions', 'onClick', 'disabled', 'hidden', 'startIcon']);
          const iconOptions = {color:"primary", ...buttonProps.iconOptions};
          const buttonState = {
            disabled: false,
            hidden: false,
            ...buttonStates[key]
          }

          button['onClick'] = ()=>buttonHandler(key);
          if (typeof buttonProps.hidden === "function") {
            button['hidden'] = buttonProps.hidden({record, error:state.error, errorMessage:state.errorMessage, buttonState});
          } else {
            button['hidden'] = buttonProps.hidden || buttonState.hidden;
          }
          if (typeof buttonProps.disabled === "function") {
            button['disabled'] = buttonProps.disabled({record, error:state.error, errorMessage:state.errorMessage, buttonState});
          } else {
            button['disabled'] = buttonProps.disabled || buttonState.disabled;
          }
          iconOptions['hidden'] = button.hidden;
          iconOptions['disabled'] = button.disabled;
          if (iconOptions.disabled) {
            iconOptions['color']=undefined;
          }

          if (buttonProps.icon) {
            button['startIcon'] = (<Icon {...iconOptions}>{buttonProps.icon}</Icon>);
          }

          return (
            <Button {...button}>
              {buttonProps.label}
            </Button>
          )
        })}
      </>
    )
  }

  return (
    <div style={{position: "relative", width: "100%", ...props.style}}>
        {title ?
          <DialogTitle id="form-dialog-slide-title" style={{position: "relative", ...props.formTitleStyle}}>
            <div style={{overflowX: "hidden", clear: "both", backgroundColor: theme.palette.primary.main, padding:"10px", ...props.titleBarStyle}}>
              {typeof title==="function"?title(record):title}
            </div>
          </DialogTitle>
          : <></>
        }
        <Alert
          key="alert"
          onChange={(open) => {
            setAlert({ ...alert, open })
          }}
          open={Validator && alert.open}
          severity={alert.severity}
          message={alert.message}
          timeOut={alert.timeOut || 10}
        />
        {Validator && validatorPosition === "top"
          ? <div style={props.validatorStyle || {margin: "0px 24px 0px 24px"}}>
              <Validator
                record={record}
                onChange={status=>{
                  setState({...state, ...status});
                }}
              />
            </div>
          : <></>
        }
        <DialogContent style={{
          position: "relative",
          backgroundColor: "#ffffff",
          overflowY: "scroll",
          maxHeight: "100%",
          minHeight: "100%",
          ...formHeight,
          ...props.formBodyStyle,
        }}>
          <div ref={formRef}>
            {children}
          </div>
          <div style={{height: 10, minHeight:10, maxHeight:10}}/>
        </DialogContent>
        {(typeof buttons === "object" && Object.entries(buttons).length > 0) ?
          <DialogActions style={props.buttonBarStyleOverride?props.buttonBarStyleOverride:{
            position: "absolute",
            top:  props.top||"calc(100vh - 220px)", // move bar up from bottom by 220px
            borderTop: (__.isEmpty(buttons) ? "" : "1px solid grey"),
            background: "#ffffff",
            ...props.buttonBarStyle
          }}>
            {/*{*/}
            {/*  Object.entries(buttons).map(([key, buttonProps]) => {*/}
            {/*    const button = __.omit(buttonProps,['label', 'icon', 'iconOptions', 'onClick', 'disabled', 'hidden', 'startIcon']);*/}
            {/*    const iconOptions = {color:"primary", ...props.iconOptions};*/}
            {/*    button['onClick'] = ()=>buttonHandler(key);*/}
            {/*    if (typeof buttonProps.hidden === "function") {*/}
            {/*      button['hidden'] = buttonProps.hidden({record, error:state.error, errorMessage:state.errorMessage});*/}
            {/*    } else {*/}
            {/*      button['hidden'] = buttonProps.hidden;*/}
            {/*    }*/}
            {/*    if (typeof buttonProps.disabled === "function") {*/}
            {/*      button['disabled'] = buttonProps.disabled({record, error:state.error, errorMessage:state.errorMessage});*/}
            {/*    } else {*/}
            {/*      button['disabled'] = buttonProps.disabled;*/}
            {/*    }*/}
            {/*    iconOptions['hidden'] = button.hidden;*/}
            {/*    iconOptions['disabled'] = button.disabled;*/}
            {/*    if (iconOptions.disabled) {*/}
            {/*      iconOptions['color']=undefined;*/}
            {/*    }*/}

            {/*    if (buttonProps.icon) {*/}
            {/*      button['startIcon'] = (<Icon {...iconOptions}>{buttonProps.icon}</Icon>);*/}
            {/*    }*/}

            {/*    return (*/}
            {/*      <Button {...button}>*/}
            {/*        {buttonProps.label}*/}
            {/*      </Button>*/}
            {/*    )*/}
            {/*  })*/}
            {/*}*/}
            <ButtonBar buttons={buttons}/>
          </DialogActions>
          :<></>
        }
        {Validator && validatorPosition === "bottom"
          ? <div style={props.validatorStyle || {margin: "0px 24px 0px 24px"}}>
            <Validator
                record={record}
                onChange={status=>{
                  setState({...state, ...status});
                }}
              />
            </div>
          : <></>
        }
    </div>
  );
}

export default Form;
